import { useEffect, useRef } from "react";

import NextPage from "../../assets/icons/NextPage.webp";
import PrevPage from "../../assets/icons/PrevPage.webp";

import "./CarouselSwiperVertical.css";

const CarouselSwiperVertical = ({ slides, alts }) => {
	const swiperRef = useRef(null);

	useEffect(() => {
		const swiperContainer = swiperRef.current;
		const params = {
			navigation: true,
			pagination: true,
			loop: true,
			injectStyles: [
				`
                  .swiper-pagination-bullet{
                    width: 16px;
                    height: 16px;
                    background-color: #808080;
                    opacity: 1;
                  }
                  .swiper-pagination-bullet-active{
                    background-color: #34a59f;
                  }
                  .swiper-pagination-bullet:hover{
                    background-color: #ffffff85;
                  }
                  .swiper-pagination-bullet-active:hover{
                    background-color: #34a59f;
                  }
              `,
			],
		};

		Object.assign(swiperContainer, params);
		swiperContainer.initialize();
	}, []);

	return (
		<div className="vertical-swiper-container-box">
			<swiper-container
				slides-per-view="1"
				navigation-next-el=".vertical-custom-next-button"
				navigation-prev-el=".vertical-custom-prev-button"
				pagination-clickable="true"
				pagination-dynamic-bullets="false"
				autoplay-delay="5000"
				autoplay-disable-on-interaction="true"
				keyboard="true"
				ref={swiperRef}
				init="false"
			>
				{slides.map((slide, i) => (
					<swiper-slide style={{ height: "auto" }} key={i}>
						<img
							src={slide}
							alt={alts[i]}
							key={i}
							style={{ height: "auto", marginBottom: "36px" }}
						/>
					</swiper-slide>
				))}
			</swiper-container>
			<div className="vertical-carousel-swiper-custom-buttons">
				<div className="vertical-nav-btn vertical-custom-prev-button">
					<img
						alt="prev-button"
						src={PrevPage}
						className="vertical-custom-carousel-swiper-button"
					/>
				</div>

				<div className="vertical-nav-btn vertical-custom-next-button">
					<img
						alt="next-button"
						src={NextPage}
						className="vertical-custom-carousel-swiper-button"
					/>
				</div>
			</div>
		</div>
	);
};

export default CarouselSwiperVertical;
